import { LoadingButton } from "@mui/lab";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { deletingDayPaycode, deletingHourPaycode, delettingShift } from "../../../utils/Schedule";
import { GlobalContext } from "../../../GlobalContext";
import { trackGaClick } from "../../../utils/analytics";
const DeletionConfirmation = ({
	open,
	setOpen,
	type,
	dataDelete,
	setDataDelete,
	dataPaycodeDay,
	setDataPaycodeDay,
	dataPaycodeHour,
	setDataPaycodeHour,
	reloading,
}) => {
	const { t } = useTranslation('schedule.form.deletion_confirmation');

	const { handlerAlert } = useContext(GlobalContext);

	const [loading, setLoading] = useState(false);
	const deletionId =
		type === "shift"
			? "schedule.delete_shift"
			: type === "PCH"
			? "schedule.delete_paycode_hours"
			: type === "PCD"
			? "schedule.delete_paycode_days"
			: "schedule.delete_unknown";

	const deletionType =
		type === "shift"
			? "shift"
			: type === "PCH"
			? "paycode_hours"
			: type === "PCD"
			? "paycode_days"
			: "unknown";
	const closing = () => {
		setOpen(false);
		dataDelete.setDisabled(false);
		dataPaycodeDay.setDisabled(false);
		dataPaycodeHour.setDisabled(false);

		setDataDelete({
			shift: null,
			person_number: null,
			date: null,
			setDisabled: () => {},
		});
		setDataPaycodeDay({
			day: null,
			setDisabled: () => {},
		});
		setDataPaycodeHour({
			hour: null,
			setDisabled: () => {},
		});
	};

	// useEffect(() => {
	// 	if (open) {
	// 		console.log("dataDelete", dataDelete);
	// 	}
	// }, [open, dataDelete]);

	return (
		<>
			<Dialog open={open} onClose={() => closing()}>
				<DialogTitle
					sx={{
						backgroundColor: (theme) => theme.palette.background.default,
					}}
				>
					<Typography variant="body3">
						{t("deletion_confirmation.title")}
					</Typography>
				</DialogTitle>

				<DialogContent
					dividers
					sx={{
						backgroundColor: (theme) => theme.palette.background.default,
					}}
				>
					<Typography variant="body3">
						{t("deletion_confirmation.message")}
					</Typography>
				</DialogContent>

				<DialogActions
					sx={{
						backgroundColor: (theme) => theme.palette.background.default,
					}}
				>
					<LoadingButton
						id={deletionId}
						data-ga-action="delete_item"
						data-ga-type={deletionType}
						variant="contained"
						disableElevation
						onClick={() => {
							trackGaClick({
								id: deletionId,
								gaAction: "delete_item",
								gaType: deletionType,
							});
							if (type === "shift") {
								delettingShift(
									setLoading,
									dataDelete.person_number,
									dataDelete.date,
									dataDelete.shift,
									closing,
									reloading,
									handlerAlert,
								);
							}

							if (type === "PCH") {
								deletingHourPaycode(setLoading, dataPaycodeHour.hour, closing, reloading, handlerAlert);
							}

							if (type === "PCD") {
								deletingDayPaycode(setLoading, dataPaycodeDay.day, closing, reloading, handlerAlert);
							}
						}}
						loading={loading}
					>
						{t("buttons.delete")}
					</LoadingButton>

					<Button
						variant="contained"
						disableElevation
						color="error"
						onClick={() => {
							closing();
						}}
						sx={{ mr: 1.5 }}
					>
						{t("buttons.cancel")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export { DeletionConfirmation };